import { render, staticRenderFns } from "./CustomerProductContracts.vue?vue&type=template&id=52697bf8&scoped=true&"
import script from "./CustomerProductContracts.vue?vue&type=script&lang=js&"
export * from "./CustomerProductContracts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProductContracts.vue?vue&type=style&index=0&id=52697bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52697bf8",
  null
  
)

export default component.exports